import tmhRequest from '@/config/tmhRequest'

export default {

     searchCustomer: function (data) {
            return tmhRequest({
                url: '/customer/tmh/customer/searchcustomer',
                method: 'post',
                params: data,
            })
        },

    searchCustomerByMobileOrCardNo: function (data) {
        return tmhRequest({
            url: '/customer/tmh/customer/searchcustomerbymobileorcardno',
            method: 'post',
            params: data,
        })
    },

    registerCustomer: function (data) {
        return tmhRequest({
            url: '/customer/tmh/customer/registercustomer',
            method: 'post',
            params: data,
        })
    },

    upgradeCustomer: function (data) {
        return tmhRequest({
            url: '/customer/tmh/customer/upgradecustomer',
            method: 'post',
            params: data,
        })
    },

    verifyPower: function (data) {
        return tmhRequest({
            url: 'customer/tmh/customer/verifypower',
            method: 'get',
            params: data,
        })
    },
}


// WEBPACK FOOTER //
// ./src/api/tmh/customer/customer.js